import styled from 'styled-components';

export const UnderlineContainer = styled.div<{
  justify?: string;
  paddingLeft?: string;
  paddingRight?: string;
}>`
  display: flex;
  justify-content: ${({ justify }) => justify || 'center'};
  padding-left: ${({ paddingLeft }) => paddingLeft || '0'};
  padding-right: ${({ paddingRight }) => paddingRight || '0'};
`;

export const Underline = styled.div<{
  color?: string;
  width?: string;
  height?: string;
}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height || '0.4rem'};
  background-color: ${({ color, theme }) => color || theme.color.white};
`;
